import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { GlassyImage } from "../GlassyImage";
import { PageContainer } from "@/components/layouts/MainLayout";
import partnerImage from "@/assets/images/partner-change-hero.webp";
import { T, THtml } from "@/components/editable/T";
import { getCustomerSuccessPath } from "@/lib/routeUtils";

interface PartnerForChangeProps {
  page?: string;
  titleKey?: string;
  titleDefault?: string;
  bodyKey?: string;
  bodyDefault?: string;
}

export function PartnerForChange({ page = "partner", titleKey = "title", titleDefault = "Begeleiding bij je implementatie", bodyKey = "body", bodyDefault = "Software alleen verandert niets. Professionals van Learned en ons gecertificeerde partnernetwerk begeleiden je bij de implementatie, van eerste inrichting tot volledige adoptie binnen de organisatie." }: PartnerForChangeProps) {
  const { i18n } = useTranslation();
  const lang = i18n.language || "nl";

  return (
    <section className="py-20 px-6">
      <PageContainer>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Blob image */}
          <div className="animate-fade-in rounded-2xl overflow-hidden aspect-square max-w-md mx-auto lg:mx-0">
            <img
              src={partnerImage}
              alt="Learned team"
              loading="lazy"
              className="w-full h-full object-cover object-center rounded-2xl"
            />
          </div>

          {/* Right - Text + CTA */}
          <div className="animate-fade-in" style={{ animationDelay: "150ms" }}>
            <h2 className="feature-section-heading mb-6 text-foreground">
              <T
                page={page}
                k={titleKey}
                d={titleDefault}
              />
            </h2>
            <THtml
              page={page}
              k={bodyKey}
              d={bodyDefault}
              as="div"
              className="text-muted-foreground text-lead leading-relaxed mb-8"
            />
            <Link
              to={getCustomerSuccessPath(lang)}
              className="inline-flex items-center gap-2 font-semibold hover:gap-3 transition-all duration-300 group"
              style={{ color: '#9055EE' }}
            >
              <T page="partner" k="cta" d="Onze services" />
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </PageContainer>
    </section>
  );
}
